import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    { path: '', redirectTo: '/app/home', pathMatch: 'full' },
    {
        path: 'app',
        loadChildren: () => import('app/app.module').then(m => m.AppModule)
    },
    {
        path: 'account',
        loadChildren: () => import('account/account.module').then(m => m.AccountModule),
        data: { preload: true }
    },
    
    // {
    //     path: 'core',
    //     loadChildren: () => import('@core/core.module').then(m => m.CoreModule),
    //     data: { preload: true }
    // },
    // {
    //     path: 'theme',
    //     loadChildren: () => import('@theme/theme.module').then(m => m.ThemeModule), // Lazy load account module
    //     data: { preload: true }
    // }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: []
})
export class RootRoutingModule { }
